import {createAction} from "redux-act";

export const setSeason = createAction<string>();
